import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function ProofSection() {
  return <div className="bg-gold/10 text-navy border-y border-gold/20" data-id="element-179">
      <SectionWrapper className="py-16 md:py-24" data-id="element-180">
        <div className="max-w-3xl mx-auto text-center" data-id="element-181">
          <div className="flex justify-center mb-6" data-id="element-182">
            <ShieldCheck className="text-gold-dark" size={48} data-id="element-183" />
          </div>
          <p className="text-xl md:text-2xl font-serif leading-relaxed text-navy" data-id="element-184">
            "Este protocolo ha sido diseñado extrayendo los principios de la{' '}
            <span className="font-bold" data-id="element-185">cronobiología</span> y aplicándolos a la
            vida de alto rendimiento. Lo que cambia en 7 días no es solo cuánto
            duerme tu bebé, sino tu capacidad de recuperar tu identidad como
            mujer capaz, productiva y en control."
          </p>
        </div>
      </SectionWrapper>
    </div>;
}